import Image from "next/image";
import { styled } from "/stitches.config.js";

export default function ToolHeader({ children }) {
  return (
    <Header>
      <a rel="noreferrer" target="_blank" href="https://instashot.xyz">
        <Image alt="instashot" width="141" height="30" src="/logo.png" />
      </a>
      <span>|</span>
      {children}
    </Header>
  );
}

const Header = styled("div", {
  width: "100%",
  height: "118px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "$2",
  color: "#697286",
  gap: 18,
  a: {
    textDecoration: "inherit",
    color: "inherit",
  },
});
